import { render, staticRenderFns } from "./Sortable.vue?vue&type=template&id=c776fc68&"
import script from "./Sortable.vue?vue&type=script&lang=js&"
export * from "./Sortable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c776fc68')) {
      api.createRecord('c776fc68', component.options)
    } else {
      api.reload('c776fc68', component.options)
    }
    module.hot.accept("./Sortable.vue?vue&type=template&id=c776fc68&", function () {
      api.rerender('c776fc68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/common/Sortable.vue"
export default component.exports